module.exports = __webpack_public_path__ + "img/icon_img_04.8d72344e.png";